import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
    root: {
        height: '100%',
        overflow: 'hidden',
    },
    pageContainer: {
        padding: tokens.spacingHorizontalSNudge,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
    },
    actionBar: {
        display: 'grid',
        gridTemplateColumns: '1fr auto',
        alignItems: 'center',
        paddingBottom: tokens.spacingVerticalS,
        flexShrink: 0,
    },
    actionButtons: {
        display: 'flex',
        gap: tokens.spacingHorizontalM,
    },
    container: {
        display: 'grid',
        gridAutoFlow: 'column',
        gridAutoColumns: '1fr',
        flex: 1,
        minHeight: 0,
        width: '100%',
        ...shorthands.gap(tokens.spacingVerticalS),
        containerType: 'inline-size',
    },
    leftColumn: {
        display: 'flex',
        flexDirection: 'column',
        ...shorthands.gap(tokens.spacingVerticalM),
        overflowY: 'auto',
        overflowX: 'hidden',
        minHeight: 0,
        paddingLeft: tokens.spacingHorizontalXXS,
        paddingRight: tokens.spacingHorizontalXXS,
        paddingBottom: tokens.spacingVerticalXXS,
        '& > *': {
            flexShrink: 0,
        },
    },
    rightColumn: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        overflowY: 'auto',
    },
    documentDialog: {
        width: '95vw',
        height: '95vh',
        maxWidth: '95vw',
        maxHeight: '95vh',
        padding: 0,
    },
    dialogCloseButton: {
        position: 'absolute',
        top: tokens.spacingVerticalM,
        right: tokens.spacingHorizontalM,
        zIndex: 1000,
    },
    dialogBackdrop: {
        backgroundColor: 'transparent',
    },
});
